import script from "./GaugesTableVoteBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./GaugesTableVoteBtn.vue?vue&type=script&setup=true&lang=ts"

import "./GaugesTableVoteBtn.vue?vue&type=style&index=0&id=4d9d626c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d9d626c"]])

export default __exports__